import { AuthApi } from "@/api/api/auth-api";
import { GetJWTRequest } from "@/api/models/get-jwtrequest";
import { RefreshJWTRequest } from "@/api/models/refresh-jwtrequest";
import {
  applyAuthTokenInterceptor,
  TokenRefreshRequest,
  setAuthTokens,
  clearAuthTokens,
  getAccessToken,
  isLoggedIn
} from "axios-jwt";
import * as jwt from "jsonwebtoken";
import Axios, { AxiosError } from "axios";
import { axios } from "@/getinfo-api/index";
import { envVars } from "@/plugins/env-vars";

const axiosInstance = Axios.create({
  baseURL: envVars.get("VUE_APP_API_HOST")
});

// Init Auth api. Creating new Axios instance for get and refresh token
export const authApi = new AuthApi({}, "", axiosInstance);

// Helpers for login, logout and refresh token
export const login = async (data: GetJWTRequest) => {
  return authApi.getJWT(data).then(res => {
    setAuthTokens({
      accessToken: res.data.token,
      refreshToken: res.data.refresh_token
    });
  });
};

// Helpers functions
export const logout = () => {
  clearAuthTokens();
};

export const refresh = async (request: RefreshJWTRequest) => {
  try {
    const data = (await authApi.refreshJWT(request)).data;

    // Reset new refresh token
    setAuthTokens({
      accessToken: data.token,
      refreshToken: data.refresh_token
    });

    return data.token;
  } catch (e) {
    const error = e as AxiosError;
    console.error(error);
  }
};

export { isLoggedIn };

// Working with JWT Payload
export interface JWTPayload {
  iat: number;
  exp: number;
  id: string;
  roles: string[];
  username: string;
}

export const getJWTPayload = (): JWTPayload | undefined => {
  const token = getAccessToken();

  if (!token) {
    return undefined;
  }

  return jwt.decode(token) as JWTPayload;
};

// Refresh token Interceptor
//@ts-ignore
const requestRefresh: TokenRefreshRequest = async (refreshToken: string) => {
  return refresh({ refresh_token: refreshToken });
};

applyAuthTokenInterceptor(axios, { requestRefresh });
